import React from 'react';
import Modal from '../../../../../shared/components/modal';

interface Props {
  onClose: () => void;
  deleteEndpoint: () => Promise<void>;
  url: string;
}

export const DeleteConfirmationModal = ({onClose, deleteEndpoint, url}: Props) => (
  <Modal show onClose={onClose}>
    <Modal.TextHeader onClose={onClose}>Delete Confirmation</Modal.TextHeader>
    <Modal.Body>
      Are you sure you want to delete the following endpoint configuration?
      <p className="shared-font bold mt-12">{url}</p>
    </Modal.Body>
    <Modal.Footer
      primaryButton={{
        text: 'Delete',
        color: 'red',
        onClick: async () => {
          await deleteEndpoint();
          onClose();
        },
      }}
      secondaryButton={{text: 'Cancel', onClick: onClose}}
    />
  </Modal>
);
